// extracted by mini-css-extract-plugin
export var aircallIframe = "_db-3";
export var fabContainer = "_db-5";
export var fabRinging = "_db-6";
export var loadingOverlay = "_db-4";
export var pulse = "_db-7";
export var widgetContent = "_db-2";
export var widgetPanel = "_db-0";
export var widgetPanelExpanded = "_db-1";